/* Kelpie — Judge.me review widget, Loox-style behaviour (product pages only).
   - Header: stars + "N Reviews" that opens a rating breakdown (average + per-star bars, click a row to filter).
   - Photo-first cards in a grid masonry (placed cards never move when more arrive), photos at natural size.
   - Reviews are fetched by this script (12 per page, photos first) from Judge.me's public endpoint and
     swapped into the widget's own list — Judge.me's handlers are never triggered, so the page never scrolls.
   - "Show more reviews" appends the next page in place with a staggered fade-in.
   - Benefit sentences in 4–5 star reviews are highlighted; verified buyers get a check badge. */
(function () {
  'use strict';
  var widget = document.getElementById('judgeme_product_reviews');
  if (!widget) return;

  var PER_PAGE = 12;
  var SORT = 'pictures_first';
  var SHOP = 'nrh2tm-r2.myshopify.com';
  var ROW = 4;                 /* grid-auto-rows in px (must match the CSS) */
  var CARD_IMG_W = 640, LIGHTBOX_IMG_W = 1400;
  var productId = window.kpProductId;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = { page: 1, total: 0, loading: false, list: null, silent: false, rating: 0, counts: null, sort: SORT };
  var holding = false, releaseTimer = null;

  function $(s, r) { return (r || widget).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || widget).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function list() { return $('.jdgm-rev-widg__reviews'); }
  function widg() { return $('.jdgm-rev-widg'); }
  function total() { var w = widg(); return w ? (parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0) : 0; }
  function average() { var w = widg(); var a = w ? parseFloat(w.getAttribute('data-average-rating')) : NaN; return isNaN(a) ? 0 : a; }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtDate(iso) { var d = new Date(iso); return isNaN(d) ? '' : pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear(); }
  function endpoint(extra, pid) {
    return 'https://cdn.judge.me/reviews/reviews_for_widget?url=' + SHOP + '&shop_domain=' + SHOP +
      '&platform=shopify&product_id=' + encodeURIComponent(pid === undefined ? productId : pid) + extra + '&ts=' + Date.now();
  }
  function pageUrl(page) {
    return endpoint('&page=' + page + '&per_page=' + PER_PAGE + '&sort_by=' + state.sort + (state.rating ? '&filter_rating=' + state.rating : ''));
  }
  function sized(url, w) {
    if (!url) return url;
    url = url.replace(/&amp;/g, '&');
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url;
  }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.7 6 21l1.3-6.8-5-4.7 6.8-.8z"/></svg>';
  function stars(n) { var h = ''; for (var i = 1; i <= 5; i++) h += '<span class="kp-star' + (i <= n ? ' is-on' : '') + '">' + STAR + '</span>'; return h; }

  /* ---------- masonry ---------- */
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) span(entries[i].target);
  }) : null;
  function gap(l) { return parseFloat(getComputedStyle(l).getPropertyValue('--kp-gap')) || 20; }
  function span(card) {
    var l = card.parentElement;
    if (!l || !l.classList.contains('kp-masonry')) return;
    if (getComputedStyle(l).display !== 'grid') { if (card.style.gridRowEnd) card.style.gridRowEnd = ''; return; }  /* single-column falls back to block flow */
    var h = card.getBoundingClientRect().height;
    if (!h) return;
    var rows = Math.ceil((h + gap(l)) / ROW);
    if (card.__kpRows !== rows) { card.__kpRows = rows; card.style.gridRowEnd = 'span ' + rows; }
  }
  function layout(l, cards) {
    if (!l) return;
    l.classList.add('kp-masonry');
    (cards || $$('.jdgm-rev', l)).forEach(function (c) {
      if (ro && !c.__kpRo) { ro.observe(c); c.__kpRo = true; }
      span(c);
    });
  }
  function relayoutSoon(l) {
    requestAnimationFrame(function () { $$('.jdgm-rev', l).forEach(span); });
    setTimeout(function () { $$('.jdgm-rev', l).forEach(span); }, 400);
    setTimeout(function () { $$('.jdgm-rev', l).forEach(span); }, 1200);
  }
  if (!ro) window.addEventListener('resize', function () { var l = list(); if (l) layout(l); });

  /* ---------- entrance animation ---------- */
  function animateIn(cards) {
    if (reduced || !cards.length) return;
    cards.forEach(function (c, i) { c.classList.add('kp-enter'); c.style.transitionDelay = Math.min(i, 11) * 45 + 'ms'; });
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      cards.forEach(function (c) { c.classList.add('kp-enter-active'); });
    }); });
    setTimeout(function () {
      cards.forEach(function (c) { c.classList.remove('kp-enter', 'kp-enter-active'); c.style.transitionDelay = ''; });
    }, 1100);
  }

  /* ---------- benefit highlights (Loox-style) ---------- */
  var OUT = /\b(stopp?e?d?|no longer|no more|less|reduced?|better|improv\w*|clear\w*|calm\w*|relie\w*|happier|gone|disappear\w*|help\w*|work\w*|lov\w*|easier|shin\w*|soft\w*|healthier|notice\w*|difference|results?|amazing|perfect|finally|great)\b/gi;
  var PROB = /\b(itch\w*|scratch\w*|lick\w*|paws?|allerg\w*|watery|sneez\w*|coat|skin|shed\w*|hot ?spots?|rash\w*|biting|chew\w*|redness|inflam\w*|tummy|stools?|anxious|anxiety|nervous|stress\w*|joints?|limp\w*|breath|teeth|energy|mobility|calmer|sleep\w*)\b/gi;
  function scoreOf(s) {
    var o = (s.match(OUT) || []).length, p = (s.match(PROB) || []).length;
    if (!o || (!p && o < 2) || s.trim().length < 28) return 0;   /* throwaway lines like "Works great." stay plain */
    return o + p;
  }
  function highlight(rev, rating) {
    var body = $('.jdgm-rev__body', rev);
    if (!body || body.getAttribute('data-kp-hl') || rating < 4) return;
    body.setAttribute('data-kp-hl', '1');
    var paras = $$('p', body); if (!paras.length) paras = [body];
    for (var k = 0; k < paras.length; k++) {
      var p = paras[k];
      if (p.querySelector('a, img, br')) continue;
      var text = p.textContent;
      var sentences = text.match(/[^.!?]+(?:[.!?]+["')\]]*|$)/g);
      if (!sentences || sentences.length < 2) continue;          /* a one-sentence review is never highlighted */
      var best = -1, bestScore = 1;
      sentences.forEach(function (s, i) { var sc = scoreOf(s); if (sc > bestScore) { bestScore = sc; best = i; } });
      if (best < 0) continue;
      var budget = Math.floor(text.length * 0.55);                /* the highlight stays a part of the review, not most of it */
      if (sentences[best].length > budget || sentences[best].length > 190) continue;   /* run-on sentences are skipped rather than painted whole */
      var chosen = {}; chosen[best] = true;
      var len = sentences[best].length;
      if (sentences[best + 1] && scoreOf(sentences[best + 1]) >= 2 && len + sentences[best + 1].length <= budget) chosen[best + 1] = true;
      p.innerHTML = sentences.map(function (s, i) {
        var m = s.match(/^(\s*)([\s\S]*?)(\s*)$/);
        return chosen[i] ? m[1] + '<mark class="kp-hl">' + esc(m[2]) + '</mark>' + m[3] : esc(s);
      }).join('');
      return;   /* one highlighted passage per review */
    }
  }

  /* ---------- per-review tidy ---------- */
  function prepare(rev, fetched, lazy) {
    var pics = $('.jdgm-rev__pics', rev);
    if (pics && $('.jdgm-rev__pic-link', pics) && rev.firstElementChild !== pics) rev.insertBefore(pics, rev.firstChild);
    if (!fetched || rev.getAttribute('data-kp-ready')) return;
    rev.setAttribute('data-kp-ready', '1');
    var header = $('.jdgm-rev__header', rev);
    if (header && !$('.jdgm-row-rating', header)) {
      var rating = document.createElement('div'); rating.className = 'jdgm-row-rating';
      var profile = document.createElement('div'); profile.className = 'jdgm-row-profile';
      ['.jdgm-rev__rating', '.jdgm-rev__timestamp', '.jdgm-rev__pinned'].forEach(function (sel) { var el = $(sel, header); if (el) rating.appendChild(el); });
      ['.jdgm-rev__icon', '.jdgm-rev__buyer-badge-wrapper', '.jdgm-rev__author-wrapper'].forEach(function (sel) { var el = $(sel, header); if (el) profile.appendChild(el); });
      $$('.jdgm-rev__br', header).forEach(function (br) { br.parentNode.removeChild(br); });
      header.insertBefore(rating, header.firstChild);
      header.appendChild(profile);
      if (rev.getAttribute('data-verified-buyer') === 'true') {
        var v = document.createElement('span'); v.className = 'kp-verified';
        v.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/><path d="M6 10.5l2.6 2.5L14 7.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified';
        profile.appendChild(v);
      }
    }
    $$('.jdgm-rev__timestamp', rev).forEach(function (t) {
      if (!t.textContent.trim()) { t.textContent = fmtDate(t.getAttribute('datetime')); t.classList.remove('jdgm-spinner'); }
    });
    var links = $$('.jdgm-rev__pic-link', rev);
    links.forEach(function (a, i) {
      var img = $('img', a);
      var src = img && (img.getAttribute('data-src') || img.getAttribute('src')) || a.href;
      if (img) {
        if (lazy) img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.setAttribute('src', sized(src, CARD_IMG_W));
        if (/[?&]width=\d+/.test(src)) { img.setAttribute('srcset', sized(src, 480) + ' 480w, ' + sized(src, 960) + ' 960w'); img.setAttribute('sizes', '(max-width: 479px) 92vw, (max-width: 749px) 46vw, 300px'); }
        var mark = function () { a.classList.add('is-loaded'); span(rev); };
        if (img.complete && img.naturalWidth) mark(); else { img.addEventListener('load', mark); img.addEventListener('error', mark); }
      }
      a.classList.remove('jdgm--loading');
      a.setAttribute('data-kp-full', sized(a.getAttribute('data-mfp-src') || a.href, LIGHTBOX_IMG_W));
    });
    if (links.length > 1 && pics && !$('.kp-pics-more', pics)) {
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'kp-pics-more'; more.setAttribute('aria-label', 'See all ' + links.length + ' photos');
      more.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm0 2v7.6l3.5-3.1 3.2 2.9 4.2-4.2L17 12.4V7H4zm17 0h1v11a3 3 0 0 1-3 3H7v-1h12a2 2 0 0 0 2-2V7z"/></svg>+' + (links.length - 1);
      more.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); lbOpen(links[1]); });
      pics.appendChild(more);
    }
    var rating = rev.querySelectorAll('.jdgm-rev__header .jdgm-star.jdgm--on').length;
    highlight(rev, rating);
  }
  function clamp(rev) {
    var body = $('.jdgm-rev__body', rev);
    if (!body || body.classList.contains('kp-clamped') || $('.kp-read-more', rev)) return;
    if (body.scrollHeight > 200) {
      body.classList.add('kp-clamped');
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'kp-read-more'; more.textContent = 'Read more';
      more.addEventListener('click', function () {
        body.style.maxHeight = body.scrollHeight + 'px';
        more.remove();
        setTimeout(function () { body.classList.remove('kp-clamped'); body.style.maxHeight = ''; }, reduced ? 0 : 380);
      });
      body.insertAdjacentElement('afterend', more);
    }
  }

  /* ---------- hold the widget height while the list is swapped ---------- */
  function hold() {
    if (holding) return;
    var h = widget.getBoundingClientRect().height;
    if (h < 40) return;
    widget.style.minHeight = Math.round(h) + 'px';
    holding = true;
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(release, 8000);
  }
  function release() { widget.style.minHeight = ''; holding = false; clearTimeout(releaseTimer); }

  /* ---------- header: stars + "N Reviews" ▾ (rating breakdown), tabs ---------- */
  var histo = null, summaryBtn = null;
  function buildHeader() {
    var header = $('.jdgm-rev-widg__header');
    if (!header || header.classList.contains('kp-head')) return;
    var inner = $('.jdgm-rev-widg__summary-inner', header) || $('.jdgm-rev-widg__summary', header) || header;
    var n = total();

    summaryBtn = document.createElement('button');
    summaryBtn.type = 'button'; summaryBtn.className = 'kp-summary';
    summaryBtn.setAttribute('aria-expanded', 'false'); summaryBtn.setAttribute('aria-controls', 'kp-histo');
    summaryBtn.innerHTML = '<span class="kp-count">' + n + ' Review' + (n === 1 ? '' : 's') + '</span>' +
      '<svg class="kp-chev" viewBox="0 0 12 8" width="14" height="14" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    inner.appendChild(summaryBtn);

    histo = document.createElement('div');
    histo.className = 'kp-histo'; histo.id = 'kp-histo'; histo.hidden = true;
    var avg = average();
    var rows = '';
    for (var r = 5; r >= 1; r--) {
      rows += '<button type="button" class="kp-histo__row" data-rating="' + r + '" aria-label="Show ' + r + ' star reviews">' +
        '<span class="kp-histo__stars">' + stars(r) + '</span><span class="kp-histo__bar"><i style="width:0%"></i></span><span class="kp-histo__n">(…)</span></button>';
    }
    histo.innerHTML = '<div class="kp-histo__avg"><span class="kp-star is-on">' + STAR + '</span><b>' + (Math.round(avg * 10) / 10).toFixed(1) + '</b></div>' + rows;
    header.appendChild(histo);
    header.classList.add('kp-head');

    summaryBtn.addEventListener('click', function (e) { e.stopPropagation(); histoToggle(); });
    histo.addEventListener('click', function (e) {
      var row = e.target.closest('.kp-histo__row');
      if (!row) return;
      var r = parseInt(row.getAttribute('data-rating'), 10);
      setRating(state.rating === r ? 0 : r);
      histoToggle(false);
    });
    document.addEventListener('click', function (e) { if (!histo.hidden && !histo.contains(e.target) && e.target !== summaryBtn) histoToggle(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !histo.hidden) { histoToggle(false); summaryBtn.focus(); } });

    /* round filter/sort button beside "Write a review" (Loox's icon button). Judge.me builds the
       actions wrapper + write link asynchronously, so place the button once the wrapper exists. */
    var fbtn = document.createElement('button');
    fbtn.type = 'button'; fbtn.className = 'kp-filter-btn';
    fbtn.setAttribute('aria-label', 'Sort and filter reviews'); fbtn.setAttribute('aria-expanded', 'false'); fbtn.setAttribute('aria-controls', 'kp-filter-menu');
    fbtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M7.5 9h9M7.5 12h9M7.5 15h5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    (function placeFilterBtn(tries) {
      var wrap = $('.jdgm-widget-actions-wrapper', header);
      var link = $('.jdgm-write-rev-link', header);
      if (wrap && link) { link.insertAdjacentElement('afterend', fbtn); return; }
      if (wrap) { wrap.appendChild(fbtn); return; }
      if ((tries || 0) < 60) { setTimeout(function () { placeFilterBtn((tries || 0) + 1); }, 100); return; }
      ($('.jdgm-row-stars', header) || header).appendChild(fbtn);   /* last resort */
    })(0);
    var menu = document.createElement('div');
    menu.className = 'kp-filter-menu'; menu.id = 'kp-filter-menu'; menu.hidden = true;
    var OPTS = [['pictures_first', 'Photos first'], ['most_recent', 'Most recent'], ['highest_rating', 'Highest rating'], ['lowest_rating', 'Lowest rating'], ['with_pictures', 'Only with photos']];
    menu.innerHTML = '<div class="kp-filter-menu__title">Sort reviews</div>' + OPTS.map(function (o) {
      return '<button type="button" class="kp-filter-menu__opt' + (o[0] === state.sort ? ' is-active' : '') + '" data-sort="' + o[0] + '">' + o[1] + '</button>';
    }).join('');
    header.appendChild(menu);
    function menuToggle(open) {
      if (open === undefined) open = menu.hidden;
      if (open) { menu.hidden = false; requestAnimationFrame(function () { menu.classList.add('is-open'); }); }
      else { menu.classList.remove('is-open'); setTimeout(function () { menu.hidden = true; }, reduced ? 0 : 180); }
      fbtn.classList.toggle('is-open', open); fbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    fbtn.addEventListener('click', function (e) { e.stopPropagation(); histoToggle(false); menuToggle(); });
    menu.addEventListener('click', function (e) {
      var opt = e.target.closest('.kp-filter-menu__opt');
      if (!opt) return;
      state.sort = opt.getAttribute('data-sort');
      $$('.kp-filter-menu__opt', menu).forEach(function (b) { b.classList.toggle('is-active', b === opt); });
      menuToggle(false);
      loadPage(1);
    });
    document.addEventListener('click', function (e) { if (!menu.hidden && !menu.contains(e.target) && !fbtn.contains(e.target)) menuToggle(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { menuToggle(false); fbtn.focus(); } });

    var tabs = document.createElement('div');
    tabs.className = 'kp-tabs';
    tabs.innerHTML = '<span class="kp-tab is-active">Product reviews <b class="kp-pill">' + n + '</b></span>' +
      '<button type="button" class="kp-filter" hidden><span class="kp-filter__stars"></span><span class="kp-filter__text"></span><span class="kp-filter__x" aria-hidden="true">&times;</span></button>';
    header.insertAdjacentElement('afterend', tabs);
    $('.kp-filter', tabs).addEventListener('click', function () { setRating(0); });
    loadCounts();
  }
  function histoToggle(open) {
    if (!histo) return;
    if (open === undefined) open = histo.hidden;
    if (open) { histo.hidden = false; requestAnimationFrame(function () { histo.classList.add('is-open'); }); }
    else { histo.classList.remove('is-open'); setTimeout(function () { histo.hidden = true; }, reduced ? 0 : 180); }
    summaryBtn.classList.toggle('is-open', open);
    summaryBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function loadCounts() {
    if (!productId || !histo) return;
    var key = 'kp-counts-' + productId, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && cached.n === total() && cached.counts) { applyCounts(cached.counts); return; }
    Promise.all([5, 4, 3, 2, 1].map(function (r) {
      return fetch(endpoint('&page=1&per_page=1&filter_rating=' + r)).then(function (x) { return x.json(); }).then(function (j) { return j.total_count || 0; }).catch(function () { return null; });
    })).then(function (arr) {
      if (arr.some(function (v) { return v === null; })) return;
      var counts = { 5: arr[0], 4: arr[1], 3: arr[2], 2: arr[3], 1: arr[4] };
      try { sessionStorage.setItem(key, JSON.stringify({ n: total(), counts: counts })); } catch (e) {}
      applyCounts(counts);
    });
  }
  function applyCounts(counts) {
    state.counts = counts;
    var sum = 0; for (var r = 1; r <= 5; r++) sum += counts[r] || 0;
    $$('.kp-histo__row', histo).forEach(function (row) {
      var r = row.getAttribute('data-rating'), n = counts[r] || 0;
      $('.kp-histo__bar i', row).style.width = (sum ? Math.round(n / sum * 1000) / 10 : 0) + '%';
      $('.kp-histo__n', row).textContent = '(' + n + ')';
    });
  }
  function setRating(r) {
    state.rating = r;
    $$('.kp-histo__row', histo).forEach(function (row) { row.classList.toggle('is-active', parseInt(row.getAttribute('data-rating'), 10) === r); });
    var chip = $('.kp-filter');
    if (chip) {
      chip.hidden = !r;
      if (r) { $('.kp-filter__stars', chip).innerHTML = stars(r); $('.kp-filter__text', chip).textContent = r + '-star reviews'; }
    }
    loadPage(1);
  }

  /* ---------- fetching pages ---------- */
  function ensureMore() {
    var body = $('.jdgm-rev-widg__body');
    if (!body || !productId) return;
    var btn = $('.kp-more');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'kp-more'; btn.textContent = 'Show more reviews';
      btn.addEventListener('click', function () { loadPage(state.page + 1); });
      body.appendChild(btn);
      widget.classList.add('kp-more-ready');
    }
    var l = list();
    var shown = l ? l.querySelectorAll('.jdgm-rev').length : 0;
    btn.hidden = !(shown && shown < state.total);
  }
  function showEmpty(scope) {
    var l = list(); if (!l) return;
    state.silent = true;
    while (l.firstChild) l.removeChild(l.firstChild);
    state.silent = false;
    state.page = 1; state.total = 0;
    l.setAttribute('data-kp-empty', 'No reviews match this filter.');
    l.classList.add('kp-empty');
    widget.classList.remove('kp-refetching');
    release();
    ensureMore();
  }
  function loadPage(page) {
    if (!productId) return;
    var l = list();
    if (!l) return;
    if (state.loading) { if (page === 1) state.queued = true; return; }
    var btn = $('.kp-more');
    var replace = page === 1;
    state.loading = true;
    if (btn && !replace) { btn.classList.add('is-loading'); btn.textContent = 'Loading…'; }
    if (replace) { hold(); }
    var wantRating = state.rating;
    fetch(pageUrl(page)).then(function (r) { return r.ok ? r.json() : { html: '', total_count: 0 }; }).then(function (j) {
      var doc = new DOMParser().parseFromString('<div>' + (j.html || '') + '</div>', 'text/html');
      var revs = $$('.jdgm-rev', doc.body);
      state.silent = true;
      if (replace) { while (l.firstChild) l.removeChild(l.firstChild); }
      l.setAttribute('data-kp-empty', 'No reviews match this filter.');
      var frag = document.createDocumentFragment();
      revs.forEach(function (rev) { prepare(rev, true, !replace); if (!reduced) rev.classList.add('kp-enter'); frag.appendChild(rev); });
      l.appendChild(frag);
      revs.forEach(clamp);
      layout(l, revs);
      relayoutSoon(l);
      state.silent = false;
      state.page = page;
      state.total = typeof j.total_count === 'number' ? j.total_count : l.querySelectorAll('.jdgm-rev').length;
      l.classList.toggle('kp-empty', !l.querySelector('.jdgm-rev'));
      animateIn(revs);
      done();
    }).catch(function () {
      /* (kept) a scope with nothing behind it (store reviews before any exist) answers with a 404 and no CORS headers */
      if (replace) {
        state.silent = true;
        while (l.firstChild) l.removeChild(l.firstChild);
        state.silent = false;
        state.page = 1; state.total = 0;
        l.setAttribute('data-kp-empty', state.scope === 'store' ? 'No store reviews yet.' : 'No reviews match this filter.');
        l.classList.add('kp-empty');
      }
      done();
    });
    function done() {
      state.loading = false;
      if (btn) { btn.classList.remove('is-loading'); btn.textContent = 'Show more reviews'; }
      if (replace) setTimeout(release, 150);
      ensureMore();
      if (state.queued || wantRating !== state.rating) { state.queued = false; loadPage(1); }
    }
  }

  /* ---------- a list rendered by Judge.me (first paint, or Judge.me re-rendering on its own) ---------- */
  function adoptList(l) {
    state.list = l; state.page = 1;
    var cards = $$('.jdgm-rev', l);
    cards.forEach(function (r) { prepare(r, false); });
    layout(l, cards);
    relayoutSoon(l);
    buildHeader(); ensureMore();
    if (productId) loadPage(1); else animateIn(cards);
  }

  /* ---------- photo lightbox ---------- */
  var lb = null, lbPics = [], lbIndex = 0, lbOpener = null;
  function lbBuild() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'kp-lightbox';
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Review photo');
    lb.hidden = true;
    lb.innerHTML = '<div class="kp-lightbox__backdrop"></div>' +
      '<figure class="kp-lightbox__stage"><img class="kp-lightbox__img" alt=""><figcaption class="kp-lightbox__caption"></figcaption></figure>' +
      '<button type="button" class="kp-lightbox__btn kp-lightbox__prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="kp-lightbox__btn kp-lightbox__next" aria-label="Next photo">&#8250;</button>' +
      '<button type="button" class="kp-lightbox__btn kp-lightbox__close" aria-label="Close">&times;</button>';
    document.body.appendChild(lb);
    lb.querySelector('.kp-lightbox__backdrop').addEventListener('click', lbClose);
    lb.querySelector('.kp-lightbox__close').addEventListener('click', lbClose);
    lb.querySelector('.kp-lightbox__prev').addEventListener('click', function () { lbShow(lbIndex - 1); });
    lb.querySelector('.kp-lightbox__next').addEventListener('click', function () { lbShow(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
    return lb;
  }
  function lbShow(i) {
    if (!lbPics.length) return;
    lbIndex = (i + lbPics.length) % lbPics.length;
    var a = lbPics[lbIndex];
    var img = lb.querySelector('.kp-lightbox__img');
    img.src = a.getAttribute('data-kp-full') || a.getAttribute('data-mfp-src') || a.href;
    img.alt = (a.querySelector('img') && a.querySelector('img').alt) || '';
    lb.querySelector('.kp-lightbox__caption').textContent = lbPics.length > 1 ? (lbIndex + 1) + ' / ' + lbPics.length : '';
    lb.classList.toggle('kp-lightbox--single', lbPics.length < 2);
  }
  function lbOpen(link) {
    var rev = link.closest('.jdgm-rev');
    lbPics = rev ? $$('.jdgm-rev__pic-link', rev) : [link];
    lbBuild();
    lbOpener = link;
    lbShow(Math.max(0, lbPics.indexOf(link)));
    lb.hidden = false;
    document.documentElement.classList.add('kp-lightbox-open');
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
    lb.querySelector('.kp-lightbox__close').focus();
  }
  function lbClose() {
    if (!lb || lb.hidden) return;
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('kp-lightbox-open');
    setTimeout(function () { lb.hidden = true; lb.querySelector('.kp-lightbox__img').removeAttribute('src'); }, reduced ? 0 : 200);
    if (lbOpener) { try { lbOpener.focus(); } catch (e) {} }
  }
  widget.addEventListener('click', function (e) {
    var link = e.target.closest('.jdgm-rev__pic-link');
    if (!link || !widget.contains(link)) return;
    if (link.closest('.jdgm-rev__pics') && link.querySelector('img')) { e.preventDefault(); e.stopPropagation(); lbOpen(link); }
  }, true);

  /* ---------- wire up ---------- */
  state.total = total();
  new MutationObserver(function (muts) {
    if (state.silent) return;
    var l = list();
    if (l && l !== state.list) { adoptList(l); return; }
    var fresh = [];
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var n = added[k];
        if (n.nodeType !== 1) continue;
        if (n.matches('.jdgm-rev')) fresh.push(n);
        else if (n.querySelector && n.querySelector('.jdgm-rev')) fresh.push.apply(fresh, n.querySelectorAll('.jdgm-rev'));
      }
    }
    if (fresh.length && l) { fresh.forEach(function (r) { prepare(r, false); }); layout(l, fresh); }
  }).observe(widget, { childList: true, subtree: true });

  window.addEventListener('load', function () { var l = list(); if (l) relayoutSoon(l); });
  var first = list();
  if (first) adoptList(first); else { buildHeader(); ensureMore(); }
})();
